import { render, staticRenderFns } from "./NurseDetalis.vue?vue&type=template&id=a1ac026e"
import script from "./NurseDetalis.vue?vue&type=script&lang=js"
export * from "./NurseDetalis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports